/** Chaves de localStorage usadas pelo módulo de notificações (logout limpa prefs + inbox). */
export const NOTIFICATION_PREFS_KEY = "xpro_notification_prefs_v1";
export const NOTIFICATION_INBOX_LOCAL_KEY = "xpro_notification_inbox_local_v1";
export const NOTIFICATION_BANNER_DISMISS_KEY = "xpro_notification_banner_dismissed_v1";
/** Sessão: usuário dispensou o aviso para ativar sons (sessionStorage). */
export const NOTIFICATION_AUDIO_UNLOCK_DISMISS_KEY = "xpro_notification_audio_unlock_dismiss_v1";

export const WEB_PUSH_ENDPOINT_STORAGE_KEY = "xpro_web_push_endpoint_v1";

/** Inbox escopado por workspace ativo (evita mistura entre tenants). */
export function notificationInboxStorageKey(workspaceSlug = null) {
  const slug = String(workspaceSlug || "").trim().toLowerCase();
  if (!slug) return null;
  return `xpro:ws:${slug}:notification_inbox_local_v1`;
}

/** Limpa dados sensíveis / por usuário; mantém banner dismiss (estado do navegador). */
export function clearNotificationStorageForLogout() {
  try {
    localStorage.removeItem(NOTIFICATION_PREFS_KEY);
    localStorage.removeItem(NOTIFICATION_INBOX_LOCAL_KEY);
    localStorage.removeItem(WEB_PUSH_ENDPOINT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
